import { IonicModule } from "ionic-angular";
import { HttpClientModule } from "@angular/common/http";
import { NgModule } from '@angular/core';
import { IonicStorageModule } from "@ionic/storage";
import { AuthenticationEndPoints } from "./endpoints/authentication-end-points";
import { ApplicationEndPoints } from "./endpoints/application-end-points";
import { WorkItemEndPoints } from "./endpoints/work-item-end-points";
import { ApiEndPoint } from "./endpoints/api-end-point";
import { UsersModel } from "./models/user/users-model";
import { UserTeamsModel } from "./models/user/user-teams-model";
import { ChatEndPoints } from "./endpoints/chat-end-points";
import { ConversationsSettingsModel } from "./models/chat/conversations-settings-model";
import { ConversationsModel } from "./models/chat/conversations-model";
import { ConversationsProvider } from "./providers/chat/conversations-provider";
import { JabberProvider } from "./providers/chat/jabber-provider";
import { JabberEndPoints } from "./endpoints/jabber-end-points";
import { ConversationsMessagesProvider } from "./providers/chat/conversations-messages-provider";
import { UsersProvider } from "./providers/user/users-provider";
import { UserTeamsProvider } from "./providers/user/user-teams-provider";
import { UsersEndPoints } from "./endpoints/users-end-points";
import { UserTeamsEndPoints } from "./endpoints/user-teams-end-points";
import { OrganizationProvider } from "./providers/organization/organization-provider";
import { AuthenticationModel } from "./models/authentication/authentication-model";
import { AuthenticationProvider } from "./providers/authentication/authentication-provider";
import { OrganizationDetailsModel } from "./models/organization/organization-details-model";
import { CustomerAppsModel } from "./models/customer-apps/customer-apps-model";
import { CustomerPortalOptionsModel } from "./models/customer-apps/customer-portal-options/customer-portal-options-model";
import { OrganizationModel } from "./models/organization/organization-model";
import { ConversationsSettingProvider } from "./providers/chat/conversations-setting-provider";
import { EncryptStorage } from "./storage/encrypt-storage";
import { OrganizationEndPoints } from "./endpoints/organization-end-points";
import { LanguageProvider } from "./providers/language/language-provider";
import { LanguageModel } from "./models/language/language-model";
import { ConversationsStatisticsProvider } from "./providers/chat/conversations-statistics-provider";
import { ConversationsMessagesModel } from "./models/chat/conversations-messages-model";
import { UsersResolverModel } from "./models/user/users-resolver-model";
import { PagesModel } from "./models/page/pages-model";
import { PagesProvider } from "./providers/page/pages-provider";
import { LoggerStorage } from "./storage/logger-storage";
import { CustomLanguageLoader } from "./loader/custom-language-loader";
import { SpacesModel } from "./models/items/spaces/spaces-model";
import { SpacesProvider } from "./providers/items/spaces/spaces-provider";
import { ItemsTypesModel } from "./models/items/types/items-types-model";
import { WorkItemsStatusProvider } from "./providers/items/statuses/work-items-status-provider";
import { ItemsTypesProvider } from "./providers/items/types/items-types-provider";
import { CpConfigurableFormModel } from "./models/items/forms/cp-configurable-form-model";
import { CpConfigurableFormProvider } from "./providers/items/form/cp-configurable-form-provider";
import { CustomFieldsModel } from "./models/items/custom-fields/custom-fields-model";
import { CustomFieldsProvider } from "./providers/items/custom-fields/custom-fields-provider";
import { WorkItemsStatusModel } from "./models/items/statuses/work-items-status-model";
import { OrganizationDetailsProvider } from "./providers/organization/organization-details-provider";
import { FilesProvider } from "./providers/files/files-provider";
import { FilesEndPoints } from "./endpoints/files-end-points";
import { FilesModel } from "./models/files/files-model";
import { MessengerModel } from "./models/messenger/messenger-model";
import { MessengerProvider } from "./providers/messenger/messenger-provider";
import { CustomerAppProvider } from "./providers/customer-apps/customer-app-provider";
import { CustomerPortalOptionsProvider } from "./providers/customer-apps/customer-portal-options/customer-portal-options-provider";
import { WorkItemsProvider } from "./providers/items/work-items/work-items-provider";
var OdModule = /** @class */ (function () {
    function OdModule() {
    }
    OdModule.forRoot = function (config) {
        return {
            ngModule: OdModule,
            providers: [
                { provide: 'config', useValue: config }
            ]
        };
    };
    OdModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        IonicModule,
                        HttpClientModule,
                        IonicStorageModule,
                    ],
                    declarations: [],
                    exports: [],
                    providers: [
                        ApiEndPoint,
                        AuthenticationEndPoints,
                        ApplicationEndPoints,
                        WorkItemEndPoints,
                        FilesEndPoints,
                        ChatEndPoints,
                        JabberEndPoints,
                        OrganizationEndPoints,
                        UsersEndPoints,
                        UserTeamsEndPoints,
                        EncryptStorage,
                        LoggerStorage,
                        CustomLanguageLoader,
                        AuthenticationModel,
                        OrganizationDetailsModel,
                        OrganizationModel,
                        MessengerModel,
                        CustomerAppsModel,
                        CustomerPortalOptionsModel,
                        ConversationsModel,
                        ConversationsMessagesModel,
                        ConversationsSettingsModel,
                        FilesModel,
                        PagesModel,
                        CustomFieldsModel,
                        CpConfigurableFormModel,
                        ItemsTypesModel,
                        WorkItemsStatusModel,
                        SpacesModel,
                        LanguageModel,
                        UsersResolverModel,
                        UsersModel,
                        UserTeamsModel,
                        AuthenticationProvider,
                        OrganizationDetailsProvider,
                        OrganizationProvider,
                        MessengerProvider,
                        CustomerAppProvider,
                        CustomerPortalOptionsProvider,
                        ConversationsProvider,
                        ConversationsMessagesProvider,
                        ConversationsSettingProvider,
                        ConversationsStatisticsProvider,
                        FilesProvider,
                        PagesProvider,
                        CustomFieldsProvider,
                        CpConfigurableFormProvider,
                        FilesProvider,
                        ItemsTypesProvider,
                        SpacesProvider,
                        WorkItemsStatusProvider,
                        WorkItemsProvider,
                        LanguageProvider,
                        JabberProvider,
                        UsersProvider,
                        UserTeamsProvider,
                    ]
                },] },
    ];
    return OdModule;
}());
export { OdModule };
//# sourceMappingURL=od.module.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/od.module.js
// module id = 529
// module chunks = 14